import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, programId) => {
    axios
      .get(routes.api.members.onboarding.index, {
        params: { program_id: programId },
      })
      .then((resp) => {
        dispatch({ type: 'LOAD', data: resp.data.data });
      });
  },
  setNextStep: ({
    dispatch, steps, isPossibleSkip, currentStep,
  }) => {
    let nextStep = currentStep + 1;

    while (
      (nextStep + 1 < steps.length)
      && ((isPossibleSkip && steps[nextStep].skip_on_continue) || steps[nextStep].completed)
    ) {
      nextStep += 1;
    }

    dispatch({ type: 'NEXT_STEP', nextStep });
  },
  setPrevStep: ({ dispatch, steps, currentStep }) => {
    let prevStep = currentStep - 1;
    while (steps[prevStep].skip_on_continue) {
      prevStep -= 1;
    }
    dispatch({ type: 'PREV_STEP', prevStep });
  },
  completeStep: (step, callback) => {
    axios
      .post(routes.api.members.onboarding.completeStep, { step })
      .then((_resp) => {
        callback();
      });
  },
  complete: (programId, callback) => {
    axios
      .post(routes.api.members.onboarding.complete, { program_id: programId })
      .then((_resp) => {
        callback();
      });
  },
  getStepRoute: (step, programId) => {
    switch (step.step) {
      case 'start_cpa':
        return routes.members.onboarding.start_talent_assessment;
      case 'cpa_form':
        return routes.members.onboarding.talent_assessment;
      case 'prepare_cpa_report':
        return routes.members.onboarding.prepare_assessment_report;
      case 'cpa_report':
        return routes.members.onboarding.talent_assessment_report;
      case 'cpa_program_report':
        return routes.members.onboarding.talent_assessment_report;
      case 'cpa_download':
        return routes.members.onboarding.talentAssessmentDownload;
      case 'prepare_build_program':
        return routes.members.onboarding.prepareBuildProgram;
      case 'order_topic':
        return routes.members.onboarding.orderTopic(programId);
      case 'coach_match':
        return routes.members.onboarding.coachMatch;
      case 'learning_style':
        return routes.members.onboarding.learningStyle;
      case 'preferences':
        return routes.members.onboarding.preferences;
      case 'finding_coach':
        return routes.members.onboarding.findingCoach;
      case 'choose_coach':
        return routes.members.onboarding.chooseCoach(programId);
      case 'finalize':
        return routes.members.onboarding.finalize;
      case 'summary':
        return routes.members.onboarding.summary(programId);
      case 'finish':
        return routes.members.onboarding.finish;
      default:
        return null;
    }
  },
};
